import React from "react"
import { Box, Link, Typography, makeStyles, useTheme } from "@material-ui/core"

import Strong from "../components/strong"

const useStyles = makeStyles(theme => ({
  footer: {
    background: theme.colors.blue[200],
    padding: "0 100px",
    [theme.breakpoints.down("sm")]: {
      padding: `0 ${theme.spacing(2.5)}px`,
    },
  },
  typography: {
    fontSize: "12px",
    fontWeight: 300,
    [theme.breakpoints.down("sm")]: {
      fontSize: `${7 / theme.typography.fontSize}rem`,
    },
  },
  linkCo: {
    fontWeight: 400,
    fontStyle: "italic",
    color: theme.colors.green[700],
    "&:hover": {
      textDecoration: "none",
    },
  },
}))

const Footer = () => {
  const classes = useStyles()
  const theme = useTheme()

  return (
    <Box
      className={classes.footer}
      component="footer"
      height="60px"
      display="flex"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <Box>
        <Typography className={classes.typography}>
          This website was designed by Ember Navarro and built by Wayne Huang.
          Copyright © {new Date().getFullYear()} All rights reserved by{" "}
          <Link className={classes.linkCo} href={theme.data.craftedOrigin}>
            Crafted Origin Media
          </Link>{" "}
          in coordination with Efficient Accounting LTD.
        </Typography>
        <Typography className={classes.typography}>
          Efficient Accounting contact information: (email){" "}
          <Strong>{theme.data.email}</Strong>, (phone){" "}
          <Strong>{theme.data.uiPhone}</Strong>; Languages spoken:{" "}
          <Strong>Spanish</Strong>, <Strong>Mandarin</Strong>, and{" "}
          <Strong>English</Strong>
        </Typography>
      </Box>
    </Box>
  )
}

export default Footer
